/**
 * Helper for calculating various element dimemsions
 *
 * @class ElementDimHelper
 */
class ElementDimHelper {
    /**
     * Returns height of component formatted as string with 'px' suffix
     *
     * @static
     * @param {Array<string>} querySelectors list of all selectors we need to subtract
     * @param {number} headerHeight 0 if not required
     * @param {number} borderWidth width of border needed for subtract. write negative number if it needs to be added
     * @returns
     * @memberof ElementDimHelper
     */
    static getContainerHeight(
        querySelectors: Array<string>,
        headerHeight: number,
        borderWidth: number,
        divider: number,
        asString: boolean
    ) {
        const windowHeight: number = window.innerHeight;
        let i: number;
        let calculatedHeight: number = windowHeight;

        if (querySelectors && querySelectors.length > 0) {
            for (i = 0; i < querySelectors.length; i += 1) {
                const wrapper = document.querySelector(querySelectors[i]);

                if (wrapper) {
                    const wrapperScrollHeight = wrapper.scrollHeight;
                    const wrapperScrollHeightInt: number = parseInt(wrapperScrollHeight.toString(), 10);
                    calculatedHeight -= wrapperScrollHeightInt;
                }
            }
        }

        if (headerHeight) {
            calculatedHeight -= headerHeight;
        }

        if (borderWidth) {
            calculatedHeight -= borderWidth;
        }

        if (divider) {
            calculatedHeight = calculatedHeight / divider;
        }

        if (asString) {
            return calculatedHeight - 2 + 'px';
        } else {
            return calculatedHeight - 2;
        }
    }

    private static getRelativeClientRect(querySelector: string) {
        const el = document.querySelector(querySelector) as HTMLElement;
        if (el && el !== null && el.offsetParent !== null) {
            const rect = el.getBoundingClientRect();
            const parentRect = el.offsetParent.getBoundingClientRect();

            return {
                left: rect.left - parentRect.left,
                width: rect.width
            };
        }
        return null;
    }

    static getNavigationStyle(querySelector: string, asString: boolean) {
        const activeLink = this.getRelativeClientRect(querySelector);

        if (activeLink) {
            if (asString) {
                return {
                    left: activeLink.left + 'px',
                    width: activeLink.width + 'px'
                };
            } else {
                return activeLink;
            }
        }
        return null;
    }
}

export default ElementDimHelper;
